import React, { Component } from 'react';
import NonValidatedField from '../NonValidatedField/NonValidatedField';
import ValidatedField from '../ValidatedField/ValidatedField';
import ValidatedDropdown from '../ValidatedDropdown/ValidatedDropdown';

const Step2 = (props) => {
  const today = new Date();
  const toDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  return (
    <div>
        <h2>פרטים אישיים</h2>
        <div className="form-inline">
          <ValidatedField disabled="disabled" label="תעודת זהות" name="identityNumber" type="text" placeholder="תעודת זהות" cols="3" tabIndex="1"/>
          <ValidatedField disabled="disabled" label="שם פרטי" name="firstName" type="text" placeholder="שם פרטי" cols="3" tabIndex="2"/>
          <ValidatedField disabled="disabled" label="שם משפחה" name="lastName" type="text" placeholder="שם משפחה" cols="3" tabIndex="3"/>
          <NonValidatedField label="שם פרטי נוסף" name="nickName" type="text" placeholder="שם פרטי נוסף" cols="3" tabIndex="4"/>
        </div>

        <div className="form-inline">
          <ValidatedField label="שם הורה" name="fatherName" type="text" placeholder="שם הורה" cols="3" tabIndex="5"/>
          <NonValidatedField label="שם משפחה קודם" name="maidenName" type="text" placeholder="שם משפחה קודם" cols="3" tabIndex="6"/>
        </div>

        <div className="form-inline">
          <ValidatedField label="תאריך לידה" name="birthDate" type="text" placeholder="dd/MM/yyyy" cols="3" tabIndex="7"/>
          <ValidatedDropdown label="מגדר" name="genderId" placeholder="" cols="3" values={props.init.genders} tabIndex="8"/>
          <ValidatedDropdown label="סטטוס משפחתי" name="familyStatusId" placeholder="" cols="3" values={props.init.familyStatuses} tabIndex="9"/>
          <ValidatedField hidestar="true" label="סטטוס משפחתי אחר" name="otherFamilyStatus" type="text" placeholder="סטטוס משפחתי אחר" cols="3" tabIndex="10"/>
        </div>

        <div className="form-inline">
          <ValidatedDropdown label="ארץ לידה" name="birthCountryId" placeholder="" cols="3" values={props.init.countries} tabIndex="11"/>
          <ValidatedField label="תאריך עליה" name="aliyaDate" type="text" placeholder="dd/MM/yyyy" hidestar="true" cols="3" tabIndex="12" hidestar="true" />
          <ValidatedField label="אזרחויות" name="citizenships" type="text" placeholder="אזרחויות" cols="3" tabIndex="13"/>
        </div>
        
        <hr />

        <div className="form-inline">
          <NonValidatedField label="הערות" name="personalDetailsComments" type="text" placeholder="הערות" cols="12" tabIndex="14"/>
        </div>

    </div>
  );
};
  
export default Step2;